// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3098z","title":"styles_title__1L7Py"};